module.exports = adpComponents;